const oss = [{
  desc: '上传',
  options: {
    url: '/file/ossUploadV2',
    method: 'post',
    baseURL: '/insapi/v3',
    formdata: true
  }
}, {
  desc: '获取地址',
  options: {
    url: '/file/generatePresignUrl',
    method: 'post',
    baseURL: '/insapi/v3',
    formdata: true
  }
}]
export default oss



// WEBPACK FOOTER //
// ./src/api/jdoss.js